import { render } from "./index.vue?vue&type=template&id=7595e42f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7595e42f&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Formulario/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7595e42f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7595e42f', __exports__)) {
    console.log('reload')
    api.reload('7595e42f', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7595e42f", () => {
    console.log('re-render')
    api.rerender('7595e42f', render)
  })

}


export default __exports__